import { render } from "./CategorySegmentTariffsForm.vue?vue&type=template&id=05e7e00a&scoped=true"
import script from "./CategorySegmentTariffsForm.vue?vue&type=script&lang=js"
export * from "./CategorySegmentTariffsForm.vue?vue&type=script&lang=js"

import "./CategorySegmentTariffsForm.vue?vue&type=style&index=0&id=05e7e00a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e7e00a"]])

export default __exports__